import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';

/**
 * A controller that shows charts for Fullfilment Requests
 */
export class FulfilmentDashboardController {
  public static $inject = [
    'fulFilmentRequestsByStatus',
    'ACTToolbarService',
    'breadcrumbService',
    'userService',
    '$translate',
    '$state'
  ];

  public summaryBarOptions: InterACT.Interfaces.ISummaryChart;
  public summaryPieOptions: any;

  private categories: { [key: string]: any };

  constructor(
    private fulFilmentRequestsByStatus: InterACT.Interfaces.Journeys.SummationResponse,
    private toolbarService: ACTToolbarService,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService,
    private $translate: ng.translate.ITranslateService,
    private $state: ng.ui.IStateService) {
    if (userService.permissions.ui &&
      userService.permissions.ui['fulfilment-dashboard'] &&
      userService.permissions.ui['fulfilment-dashboard'].canAccess) {
      this.activate();
    } else {
      $state.go('home');
    }
  }

  /**
   * Used to change state to the fulfilment-requests view passing through queryName and filterQuery params
   */
  private goToFulfilmentRequestsByStatus = (data) => {
    this.$state.go('fulfilment-requests', { queryName: data.keyName, filterQuery: data.filterQuery })
  }

  /**
   * Run upon instantation of the controller
   */
  private activate = () => {
    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      toolbar.setTitle('FULFILMENT_DASHBOARD');
    });

    this.breadcrumbService.setBreadcrumbs([{
      name: 'FULFILMENT',
      sref: 'fulfilment'
    },{
      name: 'FULFILMENT_DASHBOARD',
      sref: 'fulfilment-dashboard'
    }])

    this.categories = {
      FULFILMENT_ACCEPTED: {
        name: this.$translate.instant('STATUSES.ACCEPTED'),
        color: "rgba(89, 177, 95, 0.3)"
      },
      FULFILMENT_AWAITING_DISTRIBUTION: {
        name: this.$translate.instant('STATUSES.AWAITING_DISTRIBUTION'),
        color: "rgba(255, 200, 44, 0.3)"
      },
      FULFILMENT_CANCELLED: {
        name: this.$translate.instant('STATUSES.CANCELLED'),
        color: "rgba(238, 66, 55, 0.3)"
      },
      FULFILMENT_DISTRIBUTED: {
        name: this.$translate.instant('STATUSES.DISTRIBUTED'),
        color: "rgba(255, 200, 44, 0.3)"
      },
      FULFILMENT_HELD: {
        name: this.$translate.instant('STATUSES.HELD'),
        color: "rgba(255, 200, 44, 0.3)"
      },
      FULFILMENT_REJECTED: {
        name: this.$translate.instant('STATUSES.REJECTED'),
        color: "rgba(238, 66, 55, 0.3)"
      },
      FULFILMENT_SUCCESSFUL: {
        name: this.$translate.instant('STATUSES.SUCCESSFUL'),
        color: "rgba(89, 177, 95, 0.3)"
      },
      FULFILMENT_CONSTRUCTED: {
        name: this.$translate.instant('STATUSES.CONSTRUCTED'),
        color: "rgba(255, 200, 44, 0.3)"
      }
    }

    this.summaryBarOptions = {
      data: this.fulFilmentRequestsByStatus,
      chartId: 'chart-status',
      chartName: 'DASHBOARD.FULFILMENT_REQUESTS_BY_STATUS',
      chartType: 'bar',
      showLabels: true,
      categories: this.categories,
      onClick: this.goToFulfilmentRequestsByStatus,
      applyFilter: 'state.name',
      legend: {
        show: false
      },
      axis: {
        x: {
          label: {
            position: "outer-center"
          },
          show: true,
          type: "category",
          categories: [],
          tick: {
            centered: true,
            outer: false
          }
        },
        y: {
          show: false
        }
      },
      bar: {
        width: {
          ratio: 0.9
        }
      },
      tooltip: {
        show: false
      }
    }
  }
}
